import { handleRequest } from "../utilities/requestHandler";

export const saveRequestList = async (req_body) => {
    const response = await handleRequest("post","/request_list/saverequestlist", req_body);

    if (response?.status && typeof window !== "undefined") {
        window.dispatchEvent(new Event("requestList:refresh"));
    }

    return response;
};

export const saveProductForLater = (req_body) =>
    handleRequest("post","/saved_for_later/saveproduct", req_body);
